<template>
  <vs-popup class="chem-search-popup" title="구성물질 검색" :active.sync="showPopup">
    <p class="guide-text mb-4">한국환경공단 화학물질 정보 조회 서비스에서 물질을 검색해 구성물질명 / CAS No.를 불러옵니다.</p>

    <div class="flex gap-2 mb-4">
      <vs-select v-model="searchGubun" style="width: 130px">
        <vs-select-item v-for="opt in searchGubunOptions" :key="opt.value" :value="opt.value" :text="opt.text" />
      </vs-select>
      <vs-input class="flex-1" v-model="searchNm" placeholder="예: 2437-25-4" @keyup.enter="handleSearch" />
      <vs-button color="secondary" :disabled="searching" @click="handleSearch">검색</vs-button>
    </div>

    <div class="w-full" style="overflow-x: auto">
      <table>
        <colgroup>
          <col width="300" />
          <col width="180" />
        </colgroup>
        <thead>
          <tr>
            <th>물질명</th>
            <th>CAS No.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="searching">
            <td colspan="2" class="empty-row">검색 중입니다...</td>
          </tr>
          <tr v-else-if="chemList.length === 0">
            <td colspan="2" class="empty-row">검색어를 입력하고 검색해주세요.</td>
          </tr>
          <tr v-for="(chem, index) in chemList" :key="index" @click="handleSelectChem(chem)">
            <td>{{ chem.name }}</td>
            <td>{{ chem.casNo }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex justify-end gap-4 mt-6">
      <vs-button color="secondary" type="border" @click="cancel">닫기</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import { searchChemSubstance } from "./kecoChemApi";

export default {
  name: "PopupChemSubstanceSearch",
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      showPopup: this.value,
      searchGubun: "cas",
      searchGubunOptions: [
        { value: "name", text: "물질명" },
        { value: "cas", text: "CAS번호" },
      ],
      searchNm: "",
      searching: false,
      chemList: [],
    };
  },
  watch: {
    value: {
      handler(value) {
        this.showPopup = value;
        if (value) {
          this.searchNm = "";
          this.chemList = [];
        }
      },
    },
    showPopup(value) {
      this.$emit("input", value);
    },
  },
  methods: {
    cancel() {
      this.showPopup = false;
    },
    async handleSearch() {
      if (!this.searchNm) {
        this.$vs.notify({ title: "알림", text: "검색어를 입력해주세요.", color: "warning" });
        return;
      }
      this.searching = true;
      try {
        this.chemList = await searchChemSubstance({ searchNm: this.searchNm, searchType: this.searchGubun });
        if (this.chemList.length === 0) {
          this.$vs.notify({ title: "알림", text: "검색된 물질이 없습니다.", color: "warning" });
        }
      } catch (err) {
        this.$vs.notify({ title: "구성물질 검색 실패", text: err.message, color: "danger" });
      } finally {
        this.searching = false;
      }
    },
    handleSelectChem(chem) {
      this.$emit("select", chem);
      this.showPopup = false;
    },
  },
};
</script>

<style scoped lang="scss">
.chem-search-popup::v-deep {
  .vs-popup {
    width: 90%;
    @media (min-width: 768px) {
      width: 640px;
    }
  }
}

.guide-text {
  font-size: 13px;
  color: #888;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #cdcdcd;
    padding: 7px 11px;
  }

  th {
    font-weight: 700;
    background-color: #f9f9f9;
  }

  tbody tr:not(:first-child) {
    cursor: pointer;
    &:hover {
      background-color: #f0f0fd;
    }
  }

  .empty-row {
    padding: 20px 0;
    color: #999;
    cursor: default;
  }
}
</style>
